// extracted by mini-css-extract-plugin
module.exports = {"root":"eqMER6KBX6pMya4VHjFDT"};